import { ReactNode } from "react";
import { CalloutBox } from "../base/callout-box";
import { Style } from "./alert-variants";

interface ErrorCalloutProps {
  children: ReactNode;
  style?: Style;
}

export const ErrorCallout = ({ children, style = "outlined" }: ErrorCalloutProps) => {
  return (
    <CalloutBox color="red" style={style} className="inline">
      {children}
    </CalloutBox>
  );
};
